// extracted by mini-css-extract-plugin
module.exports = {"newsletter-container":"newsletter-confirm_newsletter-container__2FDYP","link-buttton":"newsletter-confirm_link-buttton__A6jVV","loading":"newsletter-confirm_loading__uebq0"};